// Фотографии в отзывах открываются крупно по клику.
//
// Один <dialog> на страницу, создаётся при первом клике. <dialog> даёт
// закрытие по Esc, возврат фокуса и затемнение фона нативно — своего
// обработчика клавиш и ловушки фокуса не нужно.
(function () {
  var dialog = null;
  var image = null;

  function labels() {
    var tag = document.querySelector('script[data-voices-lightbox]');
    return {
      close: (tag && tag.getAttribute('data-close-label')) || 'Close',
    };
  }

  function build() {
    if (dialog) return;

    dialog = document.createElement('dialog');
    dialog.className = 'voices-lightbox';

    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'voices-lightbox__close';
    close.setAttribute('aria-label', labels().close);
    close.innerHTML =
      '<svg viewBox="0 0 16 16" width="16" height="16" aria-hidden="true" focusable="false">' +
      '<path d="M1 1 15 15M15 1 1 15" stroke="currentColor" stroke-width="1.4" fill="none" stroke-linecap="round"/>' +
      '</svg>';
    close.addEventListener('click', function () {
      dialog.close();
    });

    image = document.createElement('img');
    image.className = 'voices-lightbox__image';
    image.alt = '';

    dialog.appendChild(close);
    dialog.appendChild(image);

    // Клик мимо картинки закрывает: у <dialog> подложка — это сам элемент,
    // поэтому событие с target === dialog означает попадание в фон.
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) dialog.close();
    });

    // Не оставляем тяжёлый файл висеть в памяти после закрытия.
    dialog.addEventListener('close', function () {
      image.removeAttribute('src');
    });

    document.body.appendChild(dialog);
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest && event.target.closest('[data-voices-photo]');
    if (!trigger) return;

    var src = trigger.getAttribute('data-full-src');
    if (!src) return;

    build();

    // <dialog> есть не везде; без него оставляем обычный переход к файлу.
    if (typeof dialog.showModal !== 'function') {
      window.open(src, '_blank', 'noopener');
      return;
    }

    event.preventDefault();
    image.src = src;
    image.alt = trigger.getAttribute('data-full-alt') || '';
    dialog.showModal();
  });
})();
